import React, { useState, useRef } from 'react';

import DocsList from './DocsList';

function isValidPDF(file) {
  return file.type === 'application/pdf';
}

export default function DocumentUploader({
  setValue,
  multiple = true,
  className,
  label,
  error,
  touched,
  value,
  loanDocuments,
  placeholder,
}) {
  const [dragOver, setDragOver] = useState(false);

  const inputRef = useRef();

  const handleDragOver = (e) => {
    e.preventDefault(); // Prevent default behavior (Prevent file from being opened)
    setDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const { files } = e.dataTransfer;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < files.length; i++) {
      if (isValidPDF(files[i])) {
        setValue(files[i]);
      }
    }
  };

  return (
    <div className={className}>
      {label && <span className="block text-sm font-medium mb-1">{label}</span>}
      <div
        onClick={() => inputRef.current.click()}
        className={`flex justify-center items-center p-4 border-2 ${
          dragOver ? 'border-blue-500 bg-blue-100' : 'border-gray-300'
        } rounded-md cursor-pointer break-all relative`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {placeholder || 'Drag & drop or Browse'}
      </div>
      <input
        accept=".pdf"
        ref={inputRef}
        type="file"
        className="hidden"
        multiple={multiple}
        onChange={(event) => {
          const { files } = event.target;

          if (loanDocuments) {
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < files.length; i++) {
              if (isValidPDF(files[i])) {
                setValue(files[i]);
              }
            }
          } else if (multiple) {
            const prevValue = value || [];

            const newFilesWithoutDuplicates = [
              ...prevValue,
              ...Array.from(files).filter(
                (file) =>
                  !prevValue.some((prevFile) => prevFile.name === file.name)
              ),
            ];

            setValue(newFilesWithoutDuplicates);
          } else {
            setValue(files[0]);
          }

          inputRef.current.value = '';
        }}
      />
      {!multiple && value && <div className="mt-1 text-sm">{value.name}</div>}
      {multiple && value && <DocsList docs={value} setDocs={setValue} />}
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
